export default __webpack_public_path__ + "static/media/squares1300.41253ee2.jpg";